export default __webpack_public_path__ + "static/media/careerSeo.dd0d9d4d.png";